'use client';

import { userState } from "@/src/recoil";
import Link from "next/link";
import React, { useEffect } from "react";
import { useRecoilValue } from "recoil";

interface ApplyButtonProps {
  jobId: string;
  IsRequesterPreviouslyApplied: boolean;
}

const ApplyButton: React.FC<ApplyButtonProps> = ({ jobId, IsRequesterPreviouslyApplied }) => {
  const user = useRecoilValue(userState);
  const lang =
    typeof window !== "undefined" ? window.location.pathname.split("/")[1] : "";
  const isArabic = lang === "ar";

  useEffect(() => {
    console.log('user', user, IsRequesterPreviouslyApplied)
  }, [IsRequesterPreviouslyApplied])
  return (
    <Link href={user ? `${isArabic ? `/ar/apply/${jobId}` : `/en/apply/${jobId}`}` : isArabic ? '/ar/login' : '/en/login'}>
      <button disabled={IsRequesterPreviouslyApplied ? true : false} className={`${IsRequesterPreviouslyApplied ? 'bg-blue-300' : 'bg-blue-500 hover:bg-blue-600'} w-full  text-white text-center py-2 rounded-xl`}>
        {!IsRequesterPreviouslyApplied ? (
          isArabic ? "تقديم" : "Apply") : (isArabic ? "تم التقديم" : "Applied")}
      </button>
    </Link>
  );
};

export default ApplyButton;
